// AutomationRuleModalFooter.jsx

import React from 'react';

// Components
import Button from 'components/button/Button';
import ModalButtons from 'components/modal/buttons/ModalButtons';
import ModalButtonSection from 'components/modal/buttonsection/ModalButtonSection';

/**
 * AutomationRuleModalFooter
 *
 * Renders the action buttons for the automation rule editor modal.
 *
 * @param {'create'|'edit'} mode - Whether the modal is creating or editing.
 * @param {boolean} isSaving - Whether a save or delete action is in progress.
 * @param {boolean} canSave - Whether the current draft can be saved.
 * @param {function} onDelete - Called when the delete action is clicked.
 * @param {function} onCancel - Called when the cancel action is clicked.
 * @param {function} onSave - Called when the save action is clicked.
 *
 * @returns {ReactNode} The rendered modal footer.
 */
const AutomationRuleModalFooter = ({
  mode,
  isSaving,
  canSave,
  onDelete,
  onCancel,
  onSave,
}) => {

  // ----- RENDER ----- //

  return (

    <ModalButtons>
      
      <ModalButtonSection align="START">

        {mode === 'edit' && (
          <Button
            iconKey="delete"
            label="Delete"
            enabled={!isSaving}
            onClick={onDelete}
          />
        )}

      </ModalButtonSection>

      <ModalButtonSection align="END">

        <Button
          label="Cancel"
          enabled={!isSaving}
          onClick={onCancel}
        />

        <Button
          iconKey="check"
          label={isSaving ? 'Saving...' : 'Save Automation'}
          enabled={canSave}
          onClick={onSave}
        />

      </ModalButtonSection>

    </ModalButtons>
  );
};

// Dev Tools
AutomationRuleModalFooter.displayName = 'AutomationRuleModalFooter';

export default AutomationRuleModalFooter;
